import React, { createContext, useContext, useMemo } from 'react';
import { useActiveOrganization, useActiveMemberRole } from '@/config/auth';

interface OrganizationContextValue {
  activeOrg: any;
  orgPending: boolean;
  refetchOrg: () => Promise<any>;
  activeMemberRole: any;
}

const OrganizationContext = createContext<OrganizationContextValue | undefined>(undefined);

export const OrganizationProvider = ({ children }: { children: React.ReactNode }) => {
  const { data: activeOrg, isPending: orgPending, refetch: refetchOrg } = useActiveOrganization();
  const { data: activeMemberRole } = useActiveMemberRole();

  const value = useMemo(
    () => ({
      activeOrg,
      orgPending,
      refetchOrg,
      activeMemberRole
    }),
    [activeOrg, orgPending, refetchOrg, activeMemberRole]
  );

  return <OrganizationContext.Provider value={value}>{children}</OrganizationContext.Provider>;
};

export const useOrganization = () => {
  const context = useContext(OrganizationContext);
  if (!context) {
    throw new Error('useOrganization must be used within an OrganizationProvider');
  }
  return context;
};
